import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { AUTH_ROUTE_PATHS } from './config';

export const AUTH_ROUTES: TApplicationRoute[] = [
  {
    id: 'auth-login',
    path: AUTH_ROUTE_PATHS.login,
    component: lazy(() => import('./pages/login-page')),
    isPublic: true, // Public route - will use EmptyLayout by default
    permissions: {
      scopes: [],
    },
  },
  {
    id: 'auth-login-failed',
    path: AUTH_ROUTE_PATHS.loginFailed,
    component: lazy(() => import('./pages/login-failed-page')),
    isPublic: true, // Public route - will use EmptyLayout by default
    permissions: {
      scopes: [],
    },
  },
  {
    id: 'auth-callback',
    path: AUTH_ROUTE_PATHS.loginCallback,
    component: lazy(() => import('./pages/auth-callback-page')),
    isPublic: true, // Public route - will use EmptyLayout by default
    permissions: {
      scopes: [],
    },
  },
  {
    id: 'auth-logout',
    path: AUTH_ROUTE_PATHS.logout,
    component: lazy(() => import('./pages/logout-page')),
    isPublic: true, // Public route - will use EmptyLayout by default
    permissions: {
      scopes: [],
    },
  },
];
